import { Modal, Form, Button, Col, Dropdown, Input, Layout, List, Menu, message, Row, Space, Select, Spin, Tooltip, FormInstance } from 'antd'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { ProFormInstance, ProFormText, ProFormTextArea, ProFormDigit, ProFormSwitch, ProFormRadio, ModalForm } from '@ant-design/pro-form'

export type ParcelCommentRequest = {
  id: string;
  visible: boolean;
  notify: boolean;
  comment: string;
};

export type ParcelCommentFormProps = {
  visible: boolean;
  onCancel: any;
  onSubmit: (values: ParcelCommentRequest) => Promise<void>;
  title: string;
  width?: any;
  formValues?: any;
};

const ParcelCommentForm: React.FC<ParcelCommentFormProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [newValue, setNewValue] = useState<any>({})
  return (
    <ModalForm title={props.title}
      grid={true}
      visible={props.visible}
      autoFocusFirstInput
      initialValues={props.formValues}
      modalProps={{
        destroyOnClose: true,
        onCancel: () => { props.onCancel(); },
      }}

      onFinish={async (values) => {
        props.onSubmit({ ...values })
      }}
      layout="horizontal"
      autoComplete="off"
      onValuesChange={(value, all) => { setNewValue({ ...newValue, ...all }); }}
      formRef={formRef} >
      <ProFormSwitch colProps={{ md: 12 }}
        name="visible"
        label="客户可见"
      />
      <ProFormSwitch colProps={{ md: 12 }}
        name="notify"
        label="通知客户"
      />
      <ProFormTextArea name="comment" label="备注" colProps={{ md: 24 }} ></ProFormTextArea>
    </ModalForm>
  )

};
export default ParcelCommentForm
